import { render, staticRenderFns } from "./captcha.vue?vue&type=template&id=1a0c5094&"
import script from "./captcha.vue?vue&type=script&lang=js&"
export * from "./captcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports